/**
 * Created by jake on 6/26/17.
 *
 */
var products = [];
var screenWidth = 0;

$(function() {
	screenWidth = $(window).width();

	$(".products .product").each(function() {
		var handle = $(this).data("handle");
		var productDOM = $(this);

		$.getJSON("/products/" + handle + ".js", function(data) {
			products[handle] = data;
			calculateVariant(productDOM.find(".option:first ul li:first"), true);
		});
	});


	$(".product .option ul li").click(function() {
		calculateVariant($(this), false);
	});
});

function calculateVariant(e, findNextAvailable) {
	var productDOM = e.closest(".product");
	var handle = productDOM.data("handle");

	if (handle) {
		var variants = products[handle].variants;
		var option = e.data("option");

		e.closest("ul").find("li").removeClass("active");
		e.addClass("active");

		if (products[handle].featured_image) {
			setProductImage(products[handle].featured_image, e);
		}

		var filteredVariants = variants;

		products[handle].options.forEach(function(option) {
			var optionPos = _.filter(products[handle].options, function(productOption) {return option.name == productOption.name});
			var selectedOption = productDOM.find(".option[data-option='" +  option.name + "']").find("li.active").data("value");

			filteredVariants = _.filter(filteredVariants, function(variant) {
				return variant["option" + optionPos[0].position] == selectedOption
			});
		});

		var chosenVariant = filteredVariants[0];

		// DOM manipulations
		if (chosenVariant.available) {
			e.closest(".product").find("form input[name=id]").val(chosenVariant.id);
			e.closest(".product").find("form button").attr("disabled", false);
			e.closest(".product").find("form button .price").html(Shopify.formatMoney(chosenVariant.price));

			if (chosenVariant.featured_image) {
				setProductImage(chosenVariant.featured_image.src, e);
			}
		} else {
			if (findNextAvailable) {
				var nextAvailable = _.find(products[handle].variants, function(variant) {return variant.available});

				products[handle].options.forEach(function(option) {
					e.closest(".product").find(".option[data-option='" + option.name + "'] li").removeClass("active");
					e.closest(".product")
						.find(".option[data-option='" + option.name + "']")
						.find("li[data-value='" + nextAvailable["option" + option.position] + "']")
						.addClass("active");

					e.closest(".product").find("form input[name=id]").val(nextAvailable.id);
					e.closest(".product").find("form button").attr("disabled", false);
					e.closest(".product").find("form button .price").html(Shopify.formatMoney(nextAvailable.price));

					if (nextAvailable.featured_image) {
						setProductImage(nextAvailable.featured_image.src, e);
					}
				});
			} else {
				e.closest(".product").find("form button .price").html("SOLD OUT");
				e.closest(".product").find("form button").attr("disabled", true);
				setProductImage(chosenVariant.featured_image.src, e);
			}
		}
	}
}

function setProductImage(imgString, e) {
	var cdnSize = null;

	if (screenWidth < 960) {
		cdnSize = "_700x";
	} else {
		cdnSize = "_300x";
	}

	var expr = /(?:\.([^.]+))?$/;
	var execd = expr.exec(imgString);
	var cdnImg = execd.input.substr(0, execd.index) + cdnSize + execd[0];

	e.closest(".product").find(".main-prod").attr("src", cdnImg);
}